<template>
  <v-dialog
    v-model="showModal"
    max-width="600"
  >
    <v-card
      outlined
      color="#ECEFF1"
    >
      <br>
      <h2 class="title-style">
        <v-icon class="icon-style">
          mdi-clock-check-outline
        </v-icon>Assign Time Slot
      </h2>
      <br>
      <div class="no-file-alert">
        <h4 v-if="isSlotLimitReached">
          Exceeded slot duration limit.
        </h4>
      </div>
      <v-form
        ref="form"
        v-model="isFormValid"
      >
        <v-container class="my-container-style">
          <v-col
            cols="12"
          >
            <v-autocomplete
              v-model="selectedTimeSlot"
              menu-props="auto"
              :items="timeSlots"
              item-value="id"
              item-text="name"
              :rules="[(v) => !!v || 'This field is required']"
              label="Time Slot*"
              @input="slotLimitCheck()"
            />
          </v-col>

          <v-col
            cols="12"
          >
            <v-select
              v-model="organizationCategory"
              menu-props="auto"
              :items="organizationCategories"
              item-text="id"
              item-value="value"
              label="Organization Category*"
              prepend-icon="mdi-domain"
              :rules="[(v) => !!v || 'This field is required']"
              single-line
            />
          </v-col>
          <p class="text-sm-left">
            *Indicates required field
          </p>
          <v-card-actions>
            <v-btn
              class="mt-2"
              color="red darken-3"
              @click="showModal = false"
            >
              Cancel
            </v-btn>
            <v-spacer />
            <v-btn
              class="mt-2"
              color="#FF3700"
              :disabled="isSlotLimitReached"
              @click="assignDigiBoardTimeSlot()"
            >
              Assign
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-form>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
  </v-dialog>
</template>
<script>
  import Constants from 'src/constants';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';

  export default {
    name: 'AssignDigiBoardTimeSlot',
    components: {
      'centre-spinner': spinner,
    },
    data () {
      return {
        showModal: true,
        loading: false,
        isFormValid: false,
        selectedTimeSlot: '',
        organizationCategory: '',
        organizationCategories: [{ id: 'Host', value: 'host' }, { id: 'Advertiser', value: 'advertiser' }],
        isSlotLimitReached: false,
      };
    },
    computed: {
      timeSlots () {
        return this.$store.getters['digiboards/getTimeSlotsList'];
      },
      digiBoardTimeSlots () {
        return this.$store.getters['digiboards/getDigiBoardTimeSlotsList'];
      },
      digiBoardDetails () {
        const digiboardTimeSlotsList = this.$store.getters['digiboards/getDigiBoardsList'];
        const digiBoardId = this.$route.params.id;
        const digiboardDetails = digiboardTimeSlotsList.filter(item => item.external_id === digiBoardId);
        return digiboardDetails[0];
      },
    },
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    async mounted () {
      await this.getTimeSlotsList();
    },
    methods: {
      async getTimeSlotsList () {
        this.loading = true;
        await this.$store.dispatch('digiboards/fetchTimeSlotsList');
        this.loading = false;
      },
      async assignDigiBoardTimeSlot () {
        if (this.$refs.form.validate() === false) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Please fill the required fields before proceeding.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          return;
        }
        const digiBoardId = this.$route.params.id;
        this.loading = true;
        await this.$store.dispatch('digiboards/assignDigiBoardTimeSlot', {
          timeSlot: {
            time_slot_id: this.selectedTimeSlot,
            type: this.organizationCategory,
          },
          digiBoard: digiBoardId,
        }).then(response => {
          this.$store.dispatch('alert/onAlert', {
            message: 'Time slot assigned successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          this.loading = false;
          this.$emit('success');
          this.showModal = false;
        }).catch(() => {
          this.loading = false;
        }); ;
      },
      slotLimitCheck () {
        var selectedTimeSlotDuration = this.timeSlots.find(x => x.id === this.selectedTimeSlot).duration;
        if (this.digiBoardTimeSlots.length > 0) {
          var totalAssignedSlotsDuration = this.digiBoardTimeSlots[0].time_slots.reduce((accum, item) => accum + item.duration, 0);
        } else {
          if (this.digiBoardDetails.total_duration < selectedTimeSlotDuration) {
          this.isSlotLimitReached = true;
          } else {
            this.isSlotLimitReached = false;
          }
          return;
        };
        var totalSlotsDuration = totalAssignedSlotsDuration + selectedTimeSlotDuration;
        if (this.digiBoardTimeSlots[0].digi_board.total_duration < totalSlotsDuration) {
          this.isSlotLimitReached = true;
        } else {
          this.isSlotLimitReached = false;
        }
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 21px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
  margin-right: 5px;
}
.my-container-style {
    padding-top: 24px;
}
.no-file-alert {
  color: #C62828;
  font-size: 18px;
  text-align: center;
  font-family: 'Times New Roman', Times, serif;
}
</style>
